import React from "react";
import {
  CollateralStrategyRow,
  CollateralStrategyType,
} from "src/VirtualOMS/types/collateral";
import { formatVirtualOmsDateTime } from "src/VirtualOMS/formatDateTime";

interface Props {
  rows: CollateralStrategyRow[];
}

const CollateralTable: React.FC<Props> = ({ rows }) => (
  <div className="overflow-x-auto p-4">
    <table className="min-w-full border border-gray-300 text-sm text-left text-gray-700">
      <thead className="bg-gray-100 text-xs uppercase">
        <tr>
          <th className="border px-4 py-2">Account</th>
          <th className="border px-4 py-2">Strategy</th>
          <th className="border px-4 py-2">Collateral Symbol</th>
          <th className="border px-4 py-2">Base Symbol</th>
          <th className="border px-4 py-2">Quantity</th>
          <th className="border px-4 py-2">Updated At</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr className="hover:bg-gray-50" key={row.id}>
            <td className="border px-4 py-2">{row.accountName}</td>
            <td className="border px-4 py-2">
              {row.strategyType === CollateralStrategyType.BullCall
                ? "Bull Call"
                : "Covered Call"}
            </td>
            <td className="border px-4 py-2">{row.collateralSymbolName || row.collateralSymbolIsin}</td>
            <td className="border px-4 py-2">{row.baseSymbolName || row.baseSymbolIsin || "-"}</td>
            <td className="border px-4 py-2">{row.quantity}</td>
            <td className="border px-4 py-2">{formatVirtualOmsDateTime(row.updatedAt)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default CollateralTable;
